"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminConsoleInputFields = void 0;
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Box_1 = __importDefault(require("@material-ui/core/Box"));
const CircularProgress_1 = __importDefault(require("@material-ui/core/CircularProgress"));
const form_checkbox_1 = require("../../../composite/form/fields/form-checkbox");
const form_editor_1 = require("../../../composite/form/fields/form-editor");
const form_panel_1 = require("../../../composite/form/fields/form-panel");
const form_submit_button_1 = require("../../../composite/form/fields/form-submit-button");
const form_select_1 = require("../../../composite/form/fields/form-select");
const admin_console_api_1 = require("./admin-console-api");
const react_intl_1 = require("react-intl");
const selector_1 = require("../../../composite/form/selectors/selector");
const common_types_1 = require("../../common-types");
function AdminConsoleInputFields({ loading, handleClear, }) {
    const intl = react_intl_1.useIntl();
    const scriptTypes = admin_console_api_1.useScriptType();
    const scriptType = selector_1.useFormSelector((data) => data.scriptType);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default, { container: true, spacing: 2 },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 6 },
                react_1.default.createElement(form_panel_1.FormPanel, { label: intl.formatMessage({
                        id: 'EAS_ADMIN_CONSOLE_LABEL_SCRIPT_LANGUAGE',
                        defaultMessage: 'Skriptovací jazyk',
                    }) },
                    react_1.default.createElement(form_select_1.FormSelect, { name: "scriptType", required: true, labelOptions: { hide: true }, source: scriptTypes, tooltipMapper: (o) => o.name, valueIsId: true }))),
            react_1.default.createElement(Grid_1.default, { item: true, xs: 6 },
                react_1.default.createElement(form_panel_1.FormPanel, { label: intl.formatMessage({
                        id: 'EAS_ADMIN_CONSOLE_LABEL_USE_TRANSACTION',
                        defaultMessage: 'Vykonat v transakci',
                    }) },
                    react_1.default.createElement(form_checkbox_1.FormCheckbox, { name: "useTransaction", labelOptions: { hide: true } })))),
        react_1.default.createElement(form_panel_1.FormPanel, { label: intl.formatMessage({
                id: 'EAS_ADMIN_CONSOLE_LABEL_SCRIPT',
                defaultMessage: 'Skript',
            }) },
            react_1.default.createElement(form_editor_1.FormEditor, { name: "script", language: scriptType === common_types_1.ScriptType.JAVASCRIPT ? 'javascript' : 'groovy', labelOptions: { hide: true }, height: 300 })),
        react_1.default.createElement(Grid_1.default, { container: true },
            react_1.default.createElement(Grid_1.default, { item: true, xs: 6 },
                react_1.default.createElement(form_submit_button_1.FormSubmitButton, { type: "submit", variant: "outlined", color: "primary", disabled: scriptType == null || loading, startIcon: loading && react_1.default.createElement(CircularProgress_1.default, { size: "20px", color: "inherit" }) },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_ADMIN_CONSOLE_BTN_SUBMIT", defaultMessage: "Vykonat" })),
                react_1.default.createElement(Box_1.default, { width: 10, display: "inline-block" }),
                react_1.default.createElement(form_submit_button_1.FormSubmitButton, { variant: "outlined", onClick: handleClear },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_ADMIN_CONSOLE_BTN_RESET", defaultMessage: "Smazat" }))))));
}
exports.AdminConsoleInputFields = AdminConsoleInputFields;
//# sourceMappingURL=admin-console-input-fields.js.map